<div class="doc-preview">
  <!-- The document is the point, so the bar stays thin: what you are looking at,
       and the two things you can do with it. -->
  <header class="doc-preview__bar">
    <div class="doc-preview__meta">
      <span class="doc-preview__title" [title]="invoice?.supplierName">{{ invoice?.supplierName || 'Document' }}</span>
      <span class="doc-preview__ref" *ngIf="invoice?.invoiceNumber">{{ invoice?.invoiceNumber }}</span>
    </div>

    <div class="doc-preview__actions">
      <button type="button" class="doc-preview__btn" (click)="downloadPdfInvoice()"
              matTooltip="Download this document" [matTooltipShowDelay]="showToolTipDelay">
        <!-- Drawn here rather than from actionBar/download.svg, which is white for the
             dark zoom bar and so vanished on this white button. -->
        <svg class="doc-preview__btn-icon" width="15" height="15" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M8 2v8M4.5 6.5 8 10l3.5-3.5M2.5 13.5h11" fill="none" stroke="currentColor"
                stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span class="doc-preview__btn-label">Download</span>
      </button>
      <button type="button" class="doc-preview__close" *ngIf="showClose" (click)="ClosePreviewSidebar()"
              aria-label="Close document">&times;</button>
    </div>
  </header>

  <div class="doc-preview__body" [ngClass]="!isHorizontalDirection ? 'container' : 'container horizontal'">
    <app-document-placeholder class="preview" [isHorizontalDirection]=isHorizontalDirection
                              *ngIf="!isLoaded && !previewError">
    </app-document-placeholder>

    <!-- Said rather than shown as an empty panel. Download reaches the file by a different
         route, so it is worth pointing at. -->
    <div class="doc-preview__error" *ngIf="previewError">
      <span class="doc-preview__error-icon" aria-hidden="true">!</span>
      <p>{{ previewError }}</p>
      <button type="button" class="doc-preview__error-btn" (click)="downloadPdfInvoice()">Download it</button>
    </div>

    <div class="upload-document" [ngClass]="!isPdf ? 'preview' : 'pdf-preview'" *ngIf="isLoaded">
      <!-- zoom / fit-to-page / render-text were ng2-pdf-viewer inputs; app-pdf-viewer declares
           none of them, and `pdfZoom` is not a property of this component either. They bound
           to nothing. -->
      <app-pdf-viewer *ngIf="isPdf" [tempFile]="tempFile"
        (downloadButtonClick)="downloadPdfInvoice()" (loadError)="onPdfError()"></app-pdf-viewer>

      <!-- Magnifier pointer: click to zoom in, Shift/Alt-click to zoom out, Ctrl/Cmd + wheel
           or pinch to zoom; the wheel scrolls and dragging moves the page. -->
      <ng-container *ngIf="!isPdf">
        <!-- Only while zoomed: back to the size it opened at. -->
        <button type="button" class="zoom-reset" *ngIf="pageScale !== 100" (click)="zoomReset(); imagePane.scrollTo(0, 0)"
                title="Back to the original size">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>
          <span class="zoom-reset__level">{{ pageScale }}%</span>
          <span>Reset</span>
        </button>
        <div #imagePane [ngClass]="!isHorizontalDirection ? 'img-wrapper' : 'img-wrapper img-horizontal'"
          class="image-viewer" appPanZoom (zoomStep)="zoomBy($event)" (zoomReset)="zoomReset()">
          <img class="image" alt="invoice" [src]="tempFile" draggable="false"
            [ngStyle]="{'width': pageScale + '%'}">
        </div>
      </ng-container>

    </div>
  </div>
</div>
